import React, { useEffect } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import { Container, Card, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";

const TermsAndConditions = () => {
    
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
      }, []);
  
      return (
    <>
  <div className="mainnav min-vh-100">


  <Helmet>
    <title>Terms & Conditions | Narayan Salvi Namkeen Manufacturer</title>

    <meta
      name="description"
      content="Read the Terms & Conditions for using Narayan Salvi Namkeen Manufacturer's website and services. Understand your responsibilities and our rights."
    />

    <meta
      name="keywords"
      content="Terms and Conditions, Narayan Salvi, Namkeen Manufacturer, Labour Contractor, Legal Terms, Service Usage Rules"
    />

    <meta name="author" content="Narayan Salvi Namkeen Manufacturer" />

    {/* Open Graph Meta Tags */}
    <meta property="og:title" content="Terms & Conditions | Narayan Salvi Namkeen Manufacturer" />
    <meta
      property="og:description"
      content="By accessing our website, you agree to our terms of use. Learn what you can and cannot do on our site."
    />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://nsnamkeenlabourcontractor.com/termcondition" />
    <meta property="og:image" content="https://nsnamkeenlabourcontractor.com/images/terms-banner.jpg" />

    {/* Responsive Viewport */}
    <meta name="viewport" content="width=device-width, initial-scale=1" />

    {/* Favicon */}
    <link rel="icon" href="/favicon.ico" />
  </Helmet>

        <Container className="py-3">
          <Row className="justify-content-center">
            <Col xs={12} md={10}>
              <Card className="shadow-lg">
                <Card.Body>
                  <Card.Title as="h2" className="middletext mb-1" data-aos="zoom-in">Terms & Conditions</Card.Title>
                  <Card.Text>
                    <p>Welcome to Narayan Salvi Namkeen Manufacturer Labour Contractor!</p>
                    <p>By accessing this website, you agree to comply with the following terms and conditions:</p>
                    <ul>
                      <li>You must not use this website for any unlawful purpose.</li>
                      <li>All content on this website is the property of Narayan Salvi Namkeen Manufacturer and may not be copied or reused without permission.</li>
                      <li>Services and offerings mentioned are subject to change without prior notice.</li>
                      <li>We are not liable for any loss or damage arising from the use of this website.</li>
                    </ul>
                    <p>Continued use of our site means you accept these terms.</p>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default TermsAndConditions;
